import { Settings } from "lucide-react";
import { useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import { mainRoutes } from "@/app/routes";
import { RouteErrorBoundary } from "@/app/RouteErrorBoundary";
import { InviteModal, InviteNavButton } from "@/features/invite/InviteModal";

export function AppShell() {
  const [inviteOpen, setInviteOpen] = useState(false);

  return (
    <div className="app-shell">
      <div className="app-body">
        <aside className="app-sidebar" aria-label="Primary navigation">
          <div className="app-sidebar-header">
            <NavLink to="/dashboard" className="sidebar-logo brand" aria-label="Liminl home">
              <span aria-hidden className="sidebar-logo-wordmark" data-figma-node="213:303">
                <img alt="" src="/figma/liminl-wordmark.svg" />
              </span>
            </NavLink>
          </div>

          <nav className="main-nav" aria-label="Primary">
            {mainRoutes.filter((route) => route.showInNav !== false).map((route) => {
              const Icon = route.icon;
              return (
                <NavLink
                  aria-label={route.navLabel}
                  key={route.path}
                  to={route.path}
                  className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
                >
                  <Icon aria-hidden size={17} />
                  <span>{route.navLabel}</span>
                </NavLink>
              );
            })}
          </nav>

          <div className="nav-actions">
            <div className="sidebar-footer">
              <InviteNavButton onClick={() => setInviteOpen(true)} />
              <div aria-hidden className="sidebar-footer-rule" />
              <NavLink
                className={({ isActive }) => `nav-link sidebar-settings${isActive ? " active" : ""}`}
                id="nav-settings"
                to="/profile"
              >
                <Settings aria-hidden size={17} />
                <span>Settings</span>
              </NavLink>
            </div>
          </div>
        </aside>

        <main className="app-main">
          <RouteErrorBoundary>
            <Outlet />
          </RouteErrorBoundary>
        </main>
      </div>

      <InviteModal onOpenChange={setInviteOpen} open={inviteOpen} />
    </div>
  );
}
